import { render } from "./Shopcart.vue?vue&type=template&id=558f5cbf&scoped=true"
import script from "./Shopcart.vue?vue&type=script&lang=js"
export * from "./Shopcart.vue?vue&type=script&lang=js"

import "./Shopcart.vue?vue&type=style&index=0&id=558f5cbf&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558f5cbf"]])

export default __exports__